import { render, staticRenderFns } from "./AppointmentInfoComponent.vue?vue&type=template&id=520cd4ab&scoped=true&"
import script from "./AppointmentInfoComponent.vue?vue&type=script&lang=js&"
export * from "./AppointmentInfoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520cd4ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-teachers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('520cd4ab')) {
      api.createRecord('520cd4ab', component.options)
    } else {
      api.reload('520cd4ab', component.options)
    }
    module.hot.accept("./AppointmentInfoComponent.vue?vue&type=template&id=520cd4ab&scoped=true&", function () {
      api.rerender('520cd4ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schedule/components/AppointmentInfoComponent.vue"
export default component.exports